import { React, useState, useRef } from "react";
// import "./OPCRegistration.css";
import "./PrivateLimitedCompany.css";
import ContactPopup from "./ContactPopup";

const OPCRegistration = () => {
  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };


  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>One Person Company (OPC) Registration</h1>

        <p className="subtitle">
          Start Your Business as a Solo Entrepreneur
        </p>

        <p className="desc">
          Get Company Status with Full Control. A One Person Company (OPC) is the perfect choice for solo founders who want the benefits of a Private Limited Company with minimal ownership complexity. We make OPC registration simple, fast, and fully compliant.
        </p>

        <div className="badges">
          <span>✔ Ideal for Solo Entrepreneurs</span>
          <span>✔ Limited Liability Protection</span>
          <span>✔ 100% Online Process</span>
          <span>✔ Expert Support</span>
        </div>

        <div className="hero-action">
          <button className="hero-btn" onClick={scrollToContact}>
            Get Started Today
          </button>
        </div>

      </div>

      {/* WHAT IS OPC */}
      <div className="section">
        <h2>What is a One Person Company (OPC)?</h2>
        <p>
          A One Person Company (OPC) is a type of company that can be formed by a single individual with limited liability protection. It allows a single owner to operate as a corporate entity with a separate legal identity.
        </p>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of OPC</h2>
        <ul>
          <li>Single ownership with full control</li>
          <li>Limited liability protection</li>
          <li>Separate legal identity</li>
          <li>Better credibility than sole proprietorship</li>
          <li>Easy to manage with fewer compliances</li>
          <li>Easy conversion into Private Limited Company</li>
        </ul>
      </div>

      {/* SERVICES */}
      <div className="section">
        <h2>Our OPC Registration Services Include</h2>
        <ul>
          <li>Digital Signature Certificate (DSC)</li>
          <li>Director Identification Number (DIN)</li>
          <li>Name Approval (RUN)</li>
          <li>MOA & AOA Drafting</li>
          <li>Company Incorporation Certificate</li>
          <li>PAN & TAN Application</li>
          <li>Bank Account Assistance</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>

        <h3>For Director:</h3>
        <ul>
          <li>PAN Card</li>
          <li>Aadhaar / Passport / Voter ID</li>
          <li>Passport-size Photograph</li>
          <li>Address Proof (Bank Statement / Utility Bill)</li>
        </ul>

        <h3>For Registered Office:</h3>
        <ul>
          <li>Rent Agreement (if rented)</li>
          <li>NOC from Owner</li>
          <li>Utility Bill</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>Registration Process</h2>
        <ul>
          <li>Consultation – Share business details</li>
          <li>Document Submission – Provide required documents</li>
          <li>Name Approval – Reserve company name</li>
          <li>Filing & Submission – Legal filings handled by us</li>
          <li>Approval – Get incorporation certificate</li>
        </ul>
      </div>

      {/* PRICING */}
      <div className="section">
        <h2>Pricing Plans</h2>

        <div className="grid">

          <div className="card blue">
            <h3>Basic Plan</h3>
            <ul>
              <li>OPC Registration</li>
              <li>PAN & TAN</li>
              <li>DSC for 1 Director</li>
            </ul>
          </div>

          <div className="card purple">
            <h3>Standard Plan</h3>
            <ul>
              <li>Everything in Basic</li>
              <li>Bank Account Assistance</li>
              <li>Basic Compliance Guidance</li>
            </ul>
          </div>

          <div className="card orange">
            <h3>Premium Plan</h3>
            <ul>
              <li>Everything in Standard</li>
              <li>GST Registration</li>
              <li>Ongoing Compliance Support</li>
            </ul>
          </div>

        </div>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Expert Legal Professionals</li>
          <li>Fast Processing</li>
          <li>Affordable Pricing</li>
          <li>Transparent Service</li>
          <li>Dedicated Customer Support</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>Who can register OPC?</b> Only an Indian resident individual.</p>
        <p><b>How many directors required?</b> Only 1 director required.</p>
        <p><b>Is nominee mandatory?</b> Yes, nominee is required.</p>
        <p><b>Can OPC convert to Pvt Ltd?</b> Yes, when business grows.</p>
      </div>

      {/* CTA */}
      <div className="cta" ref={contactRef}>
        <h2>Start Your OPC Today</h2>
        <p>Launch your business with full control and legal protection.</p>

        <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}
          >Contact Us Now</button>
           <ContactPopup
        isOpen={openPopup}
        onClose={() => setOpenPopup(false)}
      />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"}
          >Free Consultation</button>
        </div>
      </div>

    </div>
  );
};

export default OPCRegistration;